import { IChartData } from '../models/i-chart-data.interface';

// Mock data for profile royalties - Last Week (7 days)
export const PROFILE_ROYALTIES_LAST_WEEK_MOCK: IChartData[] = [
  {
    label: 'Monday',
    value: 234.5,
    tooltipLabel: 'Dec 16, 2025',
    details: [{ value: '234.5' }],
  },
  {
    label: 'Tuesday',
    value: 312.8,
    tooltipLabel: 'Dec 17, 2025',
    details: [{ value: '312.8' }],
  },
  {
    label: 'Wednesday',
    value: 189.3,
    tooltipLabel: 'Dec 18, 2025',
    details: [{ value: '189.3' }],
  },
  {
    label: 'Thursday',
    value: 421.7,
    tooltipLabel: 'Dec 19, 2025',
    details: [{ value: '421.7' }],
  },
  {
    label: 'Friday',
    value: 567.2,
    tooltipLabel: 'Dec 20, 2025',
    details: [{ value: '567.2' }],
  },
  {
    label: 'Saturday',
    value: 445.6,
    tooltipLabel: 'Dec 21, 2025',
    details: [{ value: '445.6' }],
  },
  {
    label: 'Sunday',
    value: 389.4,
    tooltipLabel: 'Dec 22, 2025',
    details: [{ value: '389.4' }],
  },
];

// Mock data for profile royalties - Last Month (30 days, sampled)
export const PROFILE_ROYALTIES_LAST_MONTH_MOCK: IChartData[] = [
  {
    label: 'Nov 23',
    value: 678.3,
    tooltipLabel: 'Nov 23, 2025',
    details: [{ value: '678.3' }],
  },
  {
    label: 'Nov 26',
    value: 734.5,
    tooltipLabel: 'Nov 26, 2025',
    details: [{ value: '734.5' }],
  },
  {
    label: 'Nov 29',
    value: 512.8,
    tooltipLabel: 'Nov 29, 2025',
    details: [{ value: '512.8' }],
  },
  {
    label: 'Dec 02',
    value: 891.2,
    tooltipLabel: 'Dec 02, 2025',
    details: [{ value: '891.2' }],
  },
  {
    label: 'Dec 05',
    value: 1024.6,
    tooltipLabel: 'Dec 05, 2025',
    details: [{ value: '1024.6' }],
  },
  {
    label: 'Dec 08',
    value: 845.3,
    tooltipLabel: 'Dec 08, 2025',
    details: [{ value: '845.3' }],
  },
  {
    label: 'Dec 11',
    value: 1156.8,
    tooltipLabel: 'Dec 11, 2025',
    details: [{ value: '1156.8' }],
  },
  {
    label: 'Dec 14',
    value: 923.4,
    tooltipLabel: 'Dec 14, 2025',
    details: [{ value: '923.4' }],
  },
  {
    label: 'Dec 17',
    value: 1287.6,
    tooltipLabel: 'Dec 17, 2025',
    details: [{ value: '1287.6' }],
  },
  {
    label: 'Dec 20',
    value: 1098.9,
    tooltipLabel: 'Dec 20, 2025',
    details: [{ value: '1098.9' }],
  },
];

// Mock data for profile royalties - Last Year (12 months)
export const PROFILE_ROYALTIES_LAST_YEAR_MOCK: IChartData[] = [
  {
    label: 'Jan',
    value: 5420.0,
    tooltipLabel: 'January',
    details: [{ value: '5420.0' }],
  },
  {
    label: 'Feb',
    value: 6235.5,
    tooltipLabel: 'February',
    details: [{ value: '6235.5' }],
  },
  {
    label: 'Mar',
    value: 7180.3,
    tooltipLabel: 'March',
    details: [{ value: '7180.3' }],
  },
  {
    label: 'Apr',
    value: 6890.7,
    tooltipLabel: 'April',
    details: [{ value: '6890.7' }],
  },
  {
    label: 'May',
    value: 8250.2,
    tooltipLabel: 'May',
    details: [{ value: '8250.2' }],
  },
  {
    label: 'Jun',
    value: 9340.8,
    tooltipLabel: 'June',
    details: [{ value: '9340.8' }],
  },
  {
    label: 'Jul',
    value: 8675.4,
    tooltipLabel: 'July',
    details: [{ value: '8675.4' }],
  },
  {
    label: 'Aug',
    value: 10120.6,
    tooltipLabel: 'August',
    details: [{ value: '10120.6' }],
  },
  {
    label: 'Sep',
    value: 11230.1,
    tooltipLabel: 'September',
    details: [{ value: '11230.1' }],
  },
  {
    label: 'Oct',
    value: 10540.9,
    tooltipLabel: 'October',
    details: [{ value: '10540.9' }],
  },
  {
    label: 'Nov',
    value: 12180.3,
    tooltipLabel: 'November',
    details: [{ value: '12180.3' }],
  },
  {
    label: 'Dec',
    value: 13450.7,
    tooltipLabel: 'December',
    details: [{ value: '13450.7' }],
  },
];

// Mock data for profile royalties - All Time (3 years, by month)
export const PROFILE_ROYALTIES_ALL_TIME_MOCK: IChartData[] = [
  {
    label: 'Jan 2023',
    value: 1850.0,
    tooltipLabel: 'January 2023',
    details: [{ value: '1850.0' }],
  },
  {
    label: 'Feb 2023',
    value: 2120.5,
    tooltipLabel: 'February 2023',
    details: [{ value: '2120.5' }],
  },
  {
    label: 'Mar 2023',
    value: 2480.3,
    tooltipLabel: 'March 2023',
    details: [{ value: '2480.3' }],
  },
  {
    label: 'Apr 2023',
    value: 2850.7,
    tooltipLabel: 'April 2023',
    details: [{ value: '2850.7' }],
  },
  {
    label: 'May 2023',
    value: 3290.2,
    tooltipLabel: 'May 2023',
    details: [{ value: '3290.2' }],
  },
  {
    label: 'Jun 2023',
    value: 3750.8,
    tooltipLabel: 'June 2023',
    details: [{ value: '3750.8' }],
  },
  {
    label: 'Jul 2023',
    value: 3475.4,
    tooltipLabel: 'July 2023',
    details: [{ value: '3475.4' }],
  },
  {
    label: 'Aug 2023',
    value: 4120.6,
    tooltipLabel: 'August 2023',
    details: [{ value: '4120.6' }],
  },
  {
    label: 'Sep 2023',
    value: 4680.1,
    tooltipLabel: 'September 2023',
    details: [{ value: '4680.1' }],
  },
  {
    label: 'Oct 2023',
    value: 4950.9,
    tooltipLabel: 'October 2023',
    details: [{ value: '4950.9' }],
  },
  {
    label: 'Nov 2023',
    value: 5320.3,
    tooltipLabel: 'November 2023',
    details: [{ value: '5320.3' }],
  },
  {
    label: 'Dec 2023',
    value: 5880.7,
    tooltipLabel: 'December 2023',
    details: [{ value: '5880.7' }],
  },
  {
    label: 'Jan 2024',
    value: 6250.0,
    tooltipLabel: 'January 2024',
    details: [{ value: '6250.0' }],
  },
  {
    label: 'Feb 2024',
    value: 6720.5,
    tooltipLabel: 'February 2024',
    details: [{ value: '6720.5' }],
  },
  {
    label: 'Mar 2024',
    value: 7380.3,
    tooltipLabel: 'March 2024',
    details: [{ value: '7380.3' }],
  },
  {
    label: 'Apr 2024',
    value: 7750.7,
    tooltipLabel: 'April 2024',
    details: [{ value: '7750.7' }],
  },
  {
    label: 'May 2024',
    value: 8490.2,
    tooltipLabel: 'May 2024',
    details: [{ value: '8490.2' }],
  },
  {
    label: 'Jun 2024',
    value: 9250.8,
    tooltipLabel: 'June 2024',
    details: [{ value: '9250.8' }],
  },
  {
    label: 'Jul 2024',
    value: 8875.4,
    tooltipLabel: 'July 2024',
    details: [{ value: '8875.4' }],
  },
  {
    label: 'Aug 2024',
    value: 9820.6,
    tooltipLabel: 'August 2024',
    details: [{ value: '9820.6' }],
  },
  {
    label: 'Sep 2024',
    value: 10680.1,
    tooltipLabel: 'September 2024',
    details: [{ value: '10680.1' }],
  },
  {
    label: 'Oct 2024',
    value: 11250.9,
    tooltipLabel: 'October 2024',
    details: [{ value: '11250.9' }],
  },
  {
    label: 'Nov 2024',
    value: 11920.3,
    tooltipLabel: 'November 2024',
    details: [{ value: '11920.3' }],
  },
  {
    label: 'Dec 2024',
    value: 12780.7,
    tooltipLabel: 'December 2024',
    details: [{ value: '12780.7' }],
  },
  {
    label: 'Jan 2025',
    value: 5420.0,
    tooltipLabel: 'January 2025',
    details: [{ value: '5420.0' }],
  },
  {
    label: 'Feb 2025',
    value: 6235.5,
    tooltipLabel: 'February 2025',
    details: [{ value: '6235.5' }],
  },
  {
    label: 'Mar 2025',
    value: 7180.3,
    tooltipLabel: 'March 2025',
    details: [{ value: '7180.3' }],
  },
  {
    label: 'Apr 2025',
    value: 6890.7,
    tooltipLabel: 'April 2025',
    details: [{ value: '6890.7' }],
  },
  {
    label: 'May 2025',
    value: 8250.2,
    tooltipLabel: 'May 2025',
    details: [{ value: '8250.2' }],
  },
  {
    label: 'Jun 2025',
    value: 9340.8,
    tooltipLabel: 'June 2025',
    details: [{ value: '9340.8' }],
  },
  {
    label: 'Jul 2025',
    value: 8675.4,
    tooltipLabel: 'July 2025',
    details: [{ value: '8675.4' }],
  },
  {
    label: 'Aug 2025',
    value: 10120.6,
    tooltipLabel: 'August 2025',
    details: [{ value: '10120.6' }],
  },
  {
    label: 'Sep 2025',
    value: 11230.1,
    tooltipLabel: 'September 2025',
    details: [{ value: '11230.1' }],
  },
  {
    label: 'Oct 2025',
    value: 10540.9,
    tooltipLabel: 'October 2025',
    details: [{ value: '10540.9' }],
  },
  {
    label: 'Nov 2025',
    value: 12180.3,
    tooltipLabel: 'November 2025',
    details: [{ value: '12180.3' }],
  },
  {
    label: 'Dec 2025',
    value: 13450.7,
    tooltipLabel: 'December 2025',
    details: [{ value: '13450.7' }],
  },
];
